module.exports = __webpack_public_path__ + "static/media/27.ad8faa21.png";